import { BaseTheme, Gradients } from "./themeRoot/config";

export const baseGradientsByTheme = (baseTheme: BaseTheme = "green"): Gradients => {
	return {
		primaryButtonGradient:
			baseTheme === "green" ? "linear-gradient(45deg, #6C992E 0%, #8DC63F 100%)" : "linear-gradient(125deg, #FA6900 0%, #F24F00 100%)",
		switchGradient:
			baseTheme === "green" ? "linear-gradient(0deg, #98E036 0%, #79b32b 100%)" : "linear-gradient(0deg, #FA6900 0%, #F24F00 100%)",

		...baseGradients,
	};
};

export const baseGradients = {
	secondaryTransparentGradient: "linear-gradient(180deg, rgba(0, 199, 82, 0.8) 0.26%, rgba(0, 199, 82, 0) 100%)",
	darkBlueGradient: "radial-gradient(96% 241% at 0% 0%, #1E1E40 0%, #2C3464 100%)",
	glowGradient: "linear-gradient(210deg, rgba(101, 104, 154, 0.75) 0%, rgba(101, 104, 154, 0) 45.81%)",
};
